import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {Button} from '../../../../basic-ui-components/button/base/button.component';

@observer
export class HelpButtonComponent extends OrbitComponent {

  handleClick(){
    this.services.externalLinks.openHelpPage();
    this.services.analytics.sendAnalytics("Navigation", "Header", "Help")
  }

  render() {

    let topHeaderRightConfig = this.services.configuration.data.header.top_header_right;

    if(!(topHeaderRightConfig && topHeaderRightConfig.help && topHeaderRightConfig.help.display)) {
      return null;
    }

    return (
      <Button
        className={"cy-header-help-button"}
        preset="flatStroked"
        icon={{Component: this.services.theme.currentTheme.icons.helpIcon}}
        onClick={this.handleClick.bind(this)}
        margin="0 0.4rem"
      />
    );
  }
}
